import { Btn, Eyebrow, Reveal } from "./primitives.jsx";

// Homepage band for the /ama page. Deliberately tiny — the full AMA (and its
// data) stays in the lazy /ama chunk; this ships only a pull quote and a link.
export default function AmaTeaser() {
  return (
    <section id="ama" data-screen-label="The Reddit AMA" className="section ama-teaser">
      <div className="section-inner">
        <div className="ama-teaser-grid">
          <div>
            <Reveal>
              <Eyebrow>From the archive · 2018</Eyebrow>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="display h-xl ama-teaser-title">
                The night Reddit asked me <em>anything.</em>
              </h2>
            </Reveal>
            <Reveal delay={240}>
              <p className="lede ama-teaser-lede">
                In April 2018 Greg took over r/baseball for two days — Disco Demolition, the Pine
                Tar Game, Bo Jackson, deep-dish pizza, the mustache. Every question and answer, word
                for word, with the photos to prove it.
              </p>
            </Reveal>
            <Reveal delay={360}>
              <Btn primary href="/ama">
                Read the full AMA
              </Btn>
            </Reveal>
          </div>
          <Reveal delay={200} className="ama-teaser-quote-col">
            <blockquote className="ama-teaser-quote">
              <p>“We were prisoners waiting for the riot to be over.”</p>
              <cite className="mono">— GREG, ON DISCO DEMOLITION NIGHT</cite>
            </blockquote>
            <blockquote className="ama-teaser-quote is-second">
              <p>“Do u ever flex on em with the ws ring?” “All the time.”</p>
              <cite className="mono">— r/baseball, GETTING AN HONEST ANSWER</cite>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

const amaTeaserStyles = typeof document !== "undefined" ? document.createElement("style") : null;
if (amaTeaserStyles) {
  amaTeaserStyles.textContent = `
.ama-teaser {
  background: linear-gradient(180deg, rgba(10, 25, 41, 0.55), rgba(5, 13, 26, 0) 70%);
}
.ama-teaser-grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 56px;
  align-items: center;
}
@media (max-width: 860px) { .ama-teaser-grid { grid-template-columns: 1fr; gap: 32px; } }
.ama-teaser-title { margin: 18px 0 20px; }
.ama-teaser-lede { max-width: 54ch; margin-bottom: 28px; }
.ama-teaser-quote {
  margin: 0;
  padding: 22px 26px;
  border: 1px solid var(--rule);
  border-left: 3px solid var(--gold);
  border-radius: 4px 10px 10px 4px;
  background: rgba(189, 155, 96, 0.05);
}
.ama-teaser-quote.is-second { margin-top: 16px; opacity: 0.92; }
.ama-teaser-quote p {
  font-family: var(--serif);
  font-style: italic;
  font-size: 1.125rem;
  line-height: 1.55;
  color: var(--bone);
  margin: 0 0 12px;
}
.ama-teaser-quote cite {
  font-style: normal;
  font-size: 0.625rem;
  letter-spacing: 0.16em;
  color: var(--gold);
}
`;
  document.head.appendChild(amaTeaserStyles);
}
